__webpack_require__.p = "/card-game/";